import(/* webpackMode: "eager" */ "/runner/_work/hubr_frontend/hubr_frontend/src/app/(private)/page.tsx");
